export const getLayoutLine = (l) => (
  <>
    {l.map((t, i) => (
      <p key={`${t}${i}`}>{t}</p>
    ))}
  </>
);
